module.exports = __webpack_public_path__ + "static/media/13.407c574c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/unused icon/13.svg
// module id = 418
// module chunks = 14